const fieldMapping = {
  id: "id",
  name: "name",
  slug: "slug",
  migrateId: "migrate_id",
  featuredTitle: "featured_title",
  featuredTitleAtCompany: "featured_title_at_company",
  featuredCompanyName: "featured_company_name",
  featuredCompanySlug: "featured_company_slug",
  featuredCompanyMigrateId: "featured_company_migrate_id",
  profileImageUrl: "profile_image_url",
  representatives: "representatives", // an array like [ {profile_id: 123, profile_slug: "mr-slug", representation_id: 456}, ... } ]
};

// Serializes an employment model object by transforming its keys using
// fieldMapping. E.g. turning {... companyId: 123 ...} into
// {... company_id: 123 ...}.
export function serializeModel(model) {
  return Object.keys(fieldMapping).reduce((acc, key) => {
    acc[fieldMapping[key]] = model[key];
    return acc;
  }, {});
}

// Deserializes an employment model object by transforming DAO keys using
// fieldMapping. E.g. turning {... company_id: 123 ...} into
// {... companyId: 123 ...}.
export function deserializeModel(model) {
  return Object.keys(fieldMapping).reduce((acc, key) => {
    acc[key] = model[fieldMapping[key]];
    return acc;
  }, {});
}

// Returns list of fields we're ready to map
export function modelFields() {
  return Object.values(fieldMapping);
}
